module.exports = __webpack_public_path__ + "static/media/Why+Phyxable.f399a9ff.png";